export default [{
  path: '/comprovante-pagamento',
  component: {
    name: 'comprovantePagamentoBase',
    template: '<router-view />',
    meta: {
      resource: 'comprovante_pagamento',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'comprovante-view',
    component: () => import('@/app/comprovante-pagamento/ComprovanteView.vue'),
    meta: {
      resource: 'comprovante_pagamento',
      action: 'read',
      navActiveLink: 'comprovante-view',
      pageTitle: 'Comprovante de arrecadação e-CAC',
      breadcrumb: [
        {
          text: 'Comprovante de arrecadação e-CAC',
          to: { name: 'comprovante-view' },
          active: true,
        },
      ],
    },
  }],
},
]
